import { DebounceEventDirective } from './debounce-event'

export {
  DebounceEventDirective
}